// Added by Sejune Oh on 2020-04-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, forwardRef } from 'react';
import {
    Divider as MaterialUIDivider,
    DividerProps as MaterialUIDividerProps
} from '@material-ui/core'

interface DividerBaseProps { }
export type DividerProps = Partial<MaterialUIDividerProps> & DividerBaseProps

export const Divider: FC<DividerProps> = forwardRef(({ ...props }, ref) => {
    return <MaterialUIDivider ref={ref} {...props}></MaterialUIDivider>
})
